import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    resources: {
      de: {
        translations: {
          Base: {
            Title: "Page4 Kundencenter"
          },
          Navigation: {
            Customer: "Stammdaten",
            Profile: "Zugangsdaten",
            Invoice: "Rechnungen",
            Account: "Webseite",
            Domain: "Domains",
            Email: "E-Mails",
            Logout: "Logout"
          },
          Accounts: {
            Overview: {
             Title: "Übersicht deiner Webseiten",
              AddButton: "Neue Webseite anlegen",
             Test: "Dies ist Text<br/>Und noch mehr Text"
            },
            Element: {
              StatusOnline : "Online",
              StatusOffline : "Offline",
              NoDefaultDomain: "Keine aktive Domain"
            },
            Snackbars: {
              DomainAdded: "Eine neue Domain wurde angelegt.",
              AccountActivated: "Das Webseitenprojekt wurde aktiviert.",
              AccountDeleted: "Die Webseite wurde gelöscht"
            }
          },
          Domains: {
            Element: {
              StatusOnline : "Online",
              StatusOffline : "Offline",
              StatusInProgress : "In Bearbeitung",
              HttpsOnline: "SSL aktiv",
              HttpsOffline: "SSL inaktiv",
              HttpsInProgress: "SSL wird generiert"
            }
          }
        }
      },
      en: {

      }
    },
    fallbackLng: 'de',
    debug: false,

    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: ".",

    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },

    // react: {
    //   wait: true
    // }
  });

export default i18n;